
import Layout from "@/components/layout/Layout";
import ProposalGenerator from "@/components/toolkit/ProposalGenerator";
import ToolkitPageWrapper from "@/components/toolkit/ToolkitPageWrapper";
import { WifiOff } from "lucide-react";
import { Button } from "@/components/ui/button";

const ProposalGeneratorPage = () => {
  return (
    <Layout 
      title="Proposal Generator | Freelance With Andy"
      description="Generate winning freelance proposals for projects with AI assistance"
      keywords="proposal generator, freelance proposal, upwork proposal, technical product manager, freelance success, andy nady"
      path="/freelance-toolkit/proposal-generator"
    >
      <ToolkitPageWrapper
        title="Proposal Generator"
        description="Generate tailored proposals for your freelance projects in seconds."
        toolName="Proposal Generator tool"
        redirectUrl="/freelance-toolkit/proposal-generator"
        errorFallback={
          <div className="bg-white rounded-lg shadow-sm p-8 text-center">
            <div className="flex items-center justify-center mb-4">
              <WifiOff className="h-8 w-8 text-red-500 mr-2" />
              <h2 className="text-2xl font-bold">Network Connection Error</h2>
            </div>
            <p className="text-muted-foreground mb-6">
              We're having trouble connecting to our AI services.
              This could be due to:
            </p>
            <ul className="text-left text-muted-foreground mb-6 max-w-md mx-auto space-y-2 list-disc pl-6">
              <li>Your internet connection being unstable</li>
              <li>A temporary outage with our AI services</li>
              <li>A VPN or firewall blocking the connection</li>
              <li>High traffic on our AI services</li>
            </ul>
            <p className="text-sm text-muted-foreground mb-6">
              Please try again in a few minutes when our services are less busy or your internet connection is more stable.
            </p>
            <Button 
              onClick={() => window.location.reload()}
              className="px-6"
            >
              Reload Page
            </Button>
          </div>
        }
      >
        <ProposalGenerator />
      </ToolkitPageWrapper>
    </Layout>
  );
};

export default ProposalGeneratorPage;
